(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bannerufo"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Add any additional JavaScript functionality here
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviewsection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Target the button by its new unique ID
    const viewAllButton = document.getElementById('reviews-view-all');
    if (viewAllButton) {
      viewAllButton.addEventListener('click', function() {
        // Add logic to view all reviews if desired
        console.log('View all reviews clicked');
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
